import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IBreadcrumbItem } from 'src/app/models/document.models';
import { EventColors } from 'src/app/models/event-colors';

@Component({
  selector: 'app-document-breadcrumb',
  templateUrl: './document-breadcrumb.component.html',
  styleUrls: ['./document-breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentBreadcrumbComponent {
  @Input() items: IBreadcrumbItem[] = [];
  @Input() colors: EventColors;

  @Output() navigate = new EventEmitter<IBreadcrumbItem>();

  get isRoot(): boolean {
    return this.items.length <= 1;
  }

  onClick(item: IBreadcrumbItem, index: number): void {
    if (index < this.items.length - 1) {
      this.navigate.emit(item);
    }
  }
}
